import { AIAliasRegistry } from '../AIAliasRegistry';

AIAliasRegistry.getInstance().registerAlias({
  alias: 'broker',
  nature: 'doc',
  table: 'documents',
  key: 'broker_name',
  label: 'Broker / Contrepartie',
  description: 'Documents filtrés par broker ou contrepartie',
  icon: '🏦',
  examples: [
    '$doc:Alasdair;2025-01-02-2026-02-10',
    '$broker:Alasdair;2025-01-02-2026-02-10',
  ],
});
